<template>
  <data-list
      ref="dataList"
      class="content"
      add-route="AddEntity"
      :add-btn="`添加${conf.name}`"
      :url="conf.url"
      :entity-name="conf.name"
      :query="configQuery"
      :columns="columns"
      :default-query="conf.defaultQuery"
      :search-key-type="searchKeyType"
      :deal-list="conf.dealList"
      :action="action"
      @detail="showDetail"
      @edit="showEdit"
      v-if="conf && auto">
    <template v-slot:button v-if="conf.export">
      <a-button type="primary" :loading="exporting" @click="exportData">{{exporting ? '正在导出' : '批量导出'}}</a-button>
    </template>
    <template v-slot:query="{form}" v-if="conf.queryForm">
      <a-form-model-item :label="item.label" v-for="item in conf.queryForm" :key="item.key">
        <component
            :is="item.component"
            :style="item.style"
            v-model="form[item.key]"
            v-bind="item.props"
            v-on="getListeners(item)">
        </component>
      </a-form-model-item>
    </template>
  </data-list>
</template>

<script>
import entityConfig from "../common/constant/entity";
import {goToDetailRoute} from "../common/js/tool";

export default {
  name: "EntityList",
  data() {
    return {
      auto: true,
      exporting: false
    }
  },
  computed: {
    type() {
      return this.$route.params.type
    },
    conf() {
      let type = this.type;
      return entityConfig[type];
    },
    searchKeyType() {
      let conf = this.conf;
      return conf && conf.searchKeyType || {name: true, title: true};
    },
    columns() {
      let conf = this.conf;
      return conf && conf.columns ? conf.columns(this) : [];
    },
    update() {
      return this.$store.getters.update;
    },
    configQuery() {
      let conf = this.conf;
      if(typeof conf.query === 'function') {
        return conf.query.call(this);
      } else {
        return conf.query;
      }
    },
    action() {
      // 遍历匹配的路由找到公共实体路由的action配置
      let matched = this.$route.matched;
      let route = matched.find(r => r.components.default.name == 'Entity');
      let res = null;
      if(route && route.meta && route.meta.action) {
        let type = this.type;
        res = route.meta.action[type] || null;
      }
      return res;
    },
    temp() {
      // 遍历匹配的路由找到公共实体路由的temp配置
      let matched = this.$route.matched;
      let route = matched.find(r => r.components.default.name == 'Entity');
      let res = null;
      if(route && route.meta && route.meta.tempMap) {
        let type = this.type;
        res = route.meta.tempMap[type] || null;
      }
      return res;
    }
  },
  watch: {
    update(val) {
      if(val && val.type == this.type) {
        this.updateList();
        this.$store.commit("changeUpdate", null);
      }
    },
    conf() {
      // 缓存路由需判断当前路由是否显示
      if(this.$route.name == 'List') {
        this.init();
      }
    },
    action() {
      // 缓存路由需判断当前路由是否显示
      if(this.$route.name == 'List') {
        this.checkPermission();
      }
    },
  },
  created() {
    this.checkPermission(true);
  },
  methods: {
    exportData() {
      if(this.exporting) return;
      this.exporting = true;
      let url = `${this.conf.url}/export`;
      this.$axios(url, {noTempleFilter: true, responseType: 'blob'}).then(res => {
        this.exporting = false;
        const content = res;
        const blob = new Blob([content])
        const fileName =`${this.conf.name}数据.xlsx`;
        if ('download' in document.createElement('a')) { // 非IE下载
          const elink = document.createElement('a')
          elink.download = fileName;
          elink.style.display = 'none'
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href) // 释放URL 对象
          document.body.removeChild(elink)
        } else { // IE10+下载
          navigator.msSaveBlob(blob, fileName)
        }
      }).catch(() => {
          this.exporting = false;
      });
    },
    checkPermission(init) {
      let action = this.action;
      if(!action) {
        this.$router.replace({name: 'Forbidden'});
      } else if(init) {
        this.init();
      }
    },
    init() {
      let conf = this.conf;
      if(conf) {
        document.title = `${conf.name}管理`;
        this.auto = !conf.ni;
        this.$store.commit("changeVs", !conf.nv);
        if(typeof conf.listInit === 'function') {
          conf.listInit.call(this);
        }
      } else if(this.type) {
        this.$router.replace({name: 'NotFound'});
      }
    },
    getListeners(item) {
      let res = null;
      if(item.update && item.update.length > 0) {
        res = {};
        item.update.forEach(type => {
          res[type] = this.updateList;
        })
      }
      return res;
    },
    updateList() {
      this.$refs.dataList.getList();
    },
    showDetail({item}) {
      goToDetailRoute(this, {item, type: this.type})
    },
    showEdit(item) {
      goToDetailRoute(this, {item, type: this.type, edit: true})
    }
  }
}
</script>

<style scoped lang="less">
</style>
